<!-- User connected navbar -->
<app-connected-navbar *ngIf="isConnected"></app-connected-navbar>

<!-- User not connected navbar -->
<app-disconnected-navbar *ngIf="!isConnected"></app-disconnected-navbar>
